import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import './AltInvesting.css';

const AltInvesting = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const altInvestingArticles = [
    {
      id: 1,
      category: 'PRIVATE EQUITY',
      title: 'Global Private Equity Fundraising Reaches $850 Billion Record',
      subtitle: 'Alternative asset managers see unprecedented investor demand amid market volatility',
      date: 'January 27, 2026',
      time: '1 hour ago',
      image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=450&fit=crop',
      slug: 'private-equity-fundraising-record'
    },
    {
      id: 2,
      category: 'HEDGE FUNDS',
      title: 'Hedge Funds Post Best Quarter Since 2021 with 12% Average Returns',
      subtitle: 'Long-short equity and macro strategies lead performance amid market turbulence',
      date: 'January 27, 2026',
      time: '3 hours ago',
      image: 'https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?w=800&h=450&fit=crop',
      slug: 'hedge-funds-best-quarter'
    },
    {
      id: 3,
      category: 'REAL ESTATE',
      title: 'Commercial Real Estate Investment Trusts Rally on Rate Cut Hopes',
      subtitle: 'Office and retail REITs surge as institutional investors increase allocations',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=800&h=450&fit=crop',
      slug: 'commercial-reits-rally'
    },
    {
      id: 4,
      category: 'COMMODITIES',
      title: 'Alternative Commodity Funds See $15 Billion Inflows in Q1',
      subtitle: 'Gold, silver and agricultural futures attract investors seeking inflation hedge',
      date: 'January 26, 2026',
      time: '1 day ago',
      image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=800&h=450&fit=crop',
      slug: 'commodity-funds-inflows'
    }
  ];

  // Alternative Investing News List - Left Column
  const altInvestingListLeft = [
    { id: 1, title: 'Private Equity Firms Deploy Record $480B in Buyouts', time: '45 minutes ago', image: 'https://images.unsplash.com/photo-1554224311-61a1d6be0bf1?w=50&h=50&fit=crop', slug: 'private-equity-record-buyouts' },
    { id: 2, title: 'Hedge Fund Strategies Outperform Traditional Portfolios', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=50&h=50&fit=crop', slug: 'hedge-fund-outperform-portfolios' },
    { id: 3, title: 'REIT Dividends Rise as Commercial Property Recovers', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=50&h=50&fit=crop', slug: 'reit-dividends-property-recovery' },
    { id: 4, title: 'Venture Capital Funding Hits $92B in Q4 2025', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=50&h=50&fit=crop', slug: 'venture-capital-q4-funding' },
    { id: 5, title: 'Alternative Credit Funds Attract $35B in New Capital', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=50&h=50&fit=crop', slug: 'alternative-credit-new-capital' },
    { id: 11, title: 'Infrastructure Investments Focus on Clean Energy', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1473186578172-c141e6798cf4?w=50&h=50&fit=crop', slug: 'infrastructure-clean-energy' },
    { id: 12, title: 'Commodity Funds See Inflows Amid Inflation Hedging', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1610375461246-83df859d849d?w=50&h=50&fit=crop', slug: 'commodity-funds-inflation-hedge' },
    { id: 13, title: 'Timber and Farmland Investments Gain Popularity', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=50&h=50&fit=crop', slug: 'timber-farmland-investments' },
    { id: 14, title: 'Art Investment Funds Report 18% Annual Returns', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=50&h=50&fit=crop', slug: 'art-investment-annual-returns' },
    { id: 15, title: 'Distressed Debt Funds Prepare for Market Opportunities', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=50&h=50&fit=crop', slug: 'distressed-debt-opportunities' }
  ];

  // Alternative Investing News List - Right Column
  const altInvestingListRight = [
    { id: 6, title: 'Pension Funds Increase Alternative Asset Allocations', time: '1 hour ago', image: 'https://images.unsplash.com/photo-1554224311-61a1d6be0bf1?w=50&h=50&fit=crop', slug: 'pension-funds-alternative-assets' },
    { id: 7, title: 'Secondaries Market Trading Volume Surges 45%', time: '2 hours ago', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=50&h=50&fit=crop', slug: 'secondaries-market-volume-surge' },
    { id: 8, title: 'Direct Lending Platforms Challenge Traditional Banks', time: '3 hours ago', image: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=50&h=50&fit=crop', slug: 'direct-lending-challenge-banks' },
    { id: 9, title: 'Impact Investing Funds Attract $28B in ESG Capital', time: '4 hours ago', image: 'https://images.unsplash.com/photo-1473186578172-c141e6798cf4?w=50&h=50&fit=crop', slug: 'impact-investing-esg-capital' },
    { id: 10, title: 'Digital Assets Funds Launch Amid Crypto Rally', time: '5 hours ago', image: 'https://images.unsplash.com/photo-1621761191319-c6fb62004040?w=50&h=50&fit=crop', slug: 'digital-assets-crypto-rally' },
    { id: 16, title: 'Long-Short Equity Strategies Post Strong Quarter', time: '6 hours ago', image: 'https://images.unsplash.com/photo-1559526324-4b87b5e36e44?w=50&h=50&fit=crop', slug: 'long-short-equity-strong-quarter' },
    { id: 17, title: 'Private Credit Market Reaches $1.5T Milestone', time: '7 hours ago', image: 'https://images.unsplash.com/photo-1579621970795-87facc2f976d?w=50&h=50&fit=crop', slug: 'private-credit-milestone' },
    { id: 18, title: 'Sports Team Ownership Emerges as Alternative Asset', time: '8 hours ago', image: 'https://images.unsplash.com/photo-1579783902614-a3fb3927b6a5?w=50&h=50&fit=crop', slug: 'sports-team-alternative-asset' },
    { id: 19, title: 'Aviation Leasing Funds Benefit from Travel Recovery', time: '9 hours ago', image: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=50&h=50&fit=crop', slug: 'aviation-leasing-travel-recovery' },
    { id: 20, title: 'Intellectual Property Funds Gain Institutional Interest', time: '10 hours ago', image: 'https://images.unsplash.com/photo-1554224311-61a1d6be0bf1?w=50&h=50&fit=crop', slug: 'ip-funds-institutional-interest' }
  ];

  return (
    <>
      <Helmet>
        <title>Alternative Investing News - Private Equity, Hedge Funds, REITs | Redbox Global</title>
        <meta name="description" content="Latest alternative investment news covering private equity, hedge funds, real estate, commodities, and non-traditional asset classes. Expert analysis and market insights." />
        <meta name="keywords" content="alternative investing, private equity, hedge funds, REITs, real estate investment, commodities, alternative assets, non-traditional investments, institutional investing" />
        
        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Alternative Investing News & Analysis - Redbox Global" />
        <meta property="og:description" content="Latest alternative investment news covering private equity, hedge funds, REITs, and non-traditional asset classes from Redbox Global." />
        <meta property="og:url" content="https://redboxglobal.com/markets/alternative-investing" />
        <meta property="og:image" content="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=630&fit=crop" />
        
        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Alternative Investing News & Analysis - Redbox Global" />
        <meta name="twitter:description" content="Latest alternative investment news covering private equity, hedge funds, REITs, and non-traditional asset classes." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1200&h=630&fit=crop" />
        
        <link rel="canonical" href="https://redboxglobal.com/markets/alternative-investing" />
      </Helmet>

      <div className="alt-investing-page">
        <div className="container">
          {/* Breadcrumb */}
          <nav className="breadcrumb">
            <Link to="/">Home</Link>
            <span className="separator">/</span>
            <Link to="/markets">Markets</Link>
            <span className="separator">/</span>
            <span className="current">Alt. Investing</span>
          </nav>

          {/* Page Header */}
          <header className="page-header">
            <h1 className="page-title">Alternative Investing</h1>
            <p className="page-description">
              Comprehensive coverage of alternative investments including private equity, hedge funds, real estate, commodities, and emerging non-traditional asset classes.
            </p>
          </header>

          {/* Featured Article */}
          <section className="featured-section">
            <Swiper
              modules={[Autoplay, Pagination]}
              autoplay={{ delay: 5000, disableOnInteraction: false }}
              pagination={{ clickable: true }}
              loop
              className="alt-investing-swiper"
            >
              {altInvestingArticles.map((article) => (
                <SwiperSlide key={article.id}>
                  <article className="featured-article">
                    <Link to={`/article/${article.slug}`} className="featured-link">
                      <div className="featured-image">
                        <img src={article.image} alt={article.title} />
                        <span className="featured-category">{article.category}</span>
                      </div>
                    </Link>
                    <div className="featured-content">
                      <h2 className="featured-title">
                        <Link to={`/article/${article.slug}`}>{article.title}</Link>
                      </h2>
                      <p className="featured-subtitle">{article.subtitle}</p>
                      <div className="article-meta">
                        <span className="author">{article.author}</span>
                        <span className="date">{article.time}</span>
                        <span className="read-time">{article.readTime}</span>
                      </div>
                    </div>
                  </article>
                </SwiperSlide>
              ))}
            </Swiper>
          </section>

          {/* Bloomberg-style Two Column List */}
          <section className="bloomberg-two-columns">
            <div className="bloomberg-column">
              {altInvestingListLeft.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
            
            <div className="bloomberg-column">
              {altInvestingListRight.map((item) => (
                <article key={item.id} className="bloomberg-item">
                  <Link to={`/article/${item.slug}`} className="bloomberg-link">
                    <div className="bloomberg-thumb">
                      <img src={item.image} alt={item.title} />
                    </div>
                    <div className="bloomberg-text">
                      <h3 className="bloomberg-title">{item.title}</h3>
                      <span className="bloomberg-time">{item.time}</span>
                    </div>
                  </Link>
                </article>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default AltInvesting;
